import { head, tail } from 'ramda';
import { DISMISS_MESSAGE, POP_MESSAGE, SHOW_MESSAGE } from './constants';

const initialState = {
  activeMessage: null,
  queue: [],
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SHOW_MESSAGE: {
      if (!state.activeMessage && !state.queue.length) {
        return { ...state, activeMessage: payload };
      }
      return {
        ...state,
        queue: [...state.queue, payload],
      };
    }

    case DISMISS_MESSAGE: {
      return {
        ...state,
        activeMessage: null,
      };
    }

    case POP_MESSAGE: {
      return {
        activeMessage: head(state.queue) || null,
        queue: tail(state.queue),
      };
    }

    default:
      return state;
  }
};

export default reducer;
